// extracted by mini-css-extract-plugin
export default {"count":"Header_count__tz+BX"};